import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, of, Subject, switchMap } from 'rxjs';
import { SettingsService } from 'src/app/core/services/http/agency-mgmt/settings.service';
import { PredictiveDataService } from 'src/app/core/services/http/maintenance/predictive-data.service';
import { JobBudgetOptionsLabel } from '../constants/job-post/job-post.enum-map';
import {
  JobBudgetOptions,
  JobPriority,
} from '../constants/job-post/job-post.enums';
import { AssignTradeResponse } from '../models/job-post/assign-trade-request.model';
import { Budget } from '../models/job-post/job.model';
@Injectable({
  providedIn: 'root',
})
export class JobPostDataService {
  private _tradeMiniProfileSubject$ = new BehaviorSubject<[string, boolean]>(null);
  private _refreshTradeeListSubject$ = new Subject<void>();
  private _refreshTradeNote$ = new Subject<boolean>();

  constructor(
    private settingSvc: SettingsService,
    private predictiveDataSvc: PredictiveDataService
  ) {}

  showTradeMiniProfile(tradeeId: string, isClosestTrade : boolean = false) {
    this._tradeMiniProfileSubject$.next([tradeeId, isClosestTrade]);
  }

  tradeMiniProfile() {
    return this._tradeMiniProfileSubject$.pipe(filter((data) => data != null));
  }

  requestRefreshTradeeList() {
    this._refreshTradeeListSubject$.next();
  }

  refreshTradeeList() {
    return this._refreshTradeeListSubject$;
  }

  refreshTradeNote() {
    this._refreshTradeNote$.next(true);
  }

  getTradeNote() {
    return this._refreshTradeNote$;
  }

  getBudget(title: string, description: string) {
    return this.settingSvc.getBudget().pipe(
      switchMap((res) => {
        if (res && res != null) return of(res);
        return this.predictiveDataSvc.getJobBudget(title, description).pipe(
          map((res2) => {
            return {
              amount: 0,
              maxAmount: 0,
              option: this.setBudgetOptionTroughBudget(res2.budget),
            };
          })
        );
      })
    );
  }

  getAiJobBudget(title: string, description: string, isReqFromAiJob:boolean = true) {
    return this.settingSvc.getBudget().pipe(
      switchMap((res) => {
        if (res && res != null) return of(res);
        return this.predictiveDataSvc.getJobBudget(title, description, isReqFromAiJob).pipe(
          map((res2) => {
            return {
              amount: res2.budget,
              maxAmount: 0,
              option: JobBudgetOptions.Custom,
            };
          })
        );
      })
    );
  }

  getUrgency() {
    return this.settingSvc.getUrgency().pipe(
      map((res) => {
        return this.setJobPriority(res.option);
      })
    );
  }

  setJobPriority(urgency: number) {
    let jobPriority: JobPriority;
    if (urgency == -1) jobPriority = JobPriority.Emergency;
    else if (urgency == 1) jobPriority = JobPriority.Urgent;
    else jobPriority = JobPriority.Normal;
    return jobPriority;
  }

  setBudgetOptionTroughBudget(budget: number) {
    if (budget == 0) return JobBudgetOptions.UnSure;

    let budgetOption: JobBudgetOptions;
    if (budget < 500) budgetOption = JobBudgetOptions.Under500;
    else if (budget >= 500 && budget < 1000)
      budgetOption = JobBudgetOptions.Between500N1000;
    else if (budget >= 1000 && budget < 2000)
      budgetOption = JobBudgetOptions.Between1000N2000;
    else if (budget >= 2000 && budget < 5000)
      budgetOption = JobBudgetOptions.Between2000N5000;
    else if (budget >= 5000) budgetOption = JobBudgetOptions.Over5000;
    else budgetOption = JobBudgetOptions.Custom;
    return budgetOption;
  }

  setAssignTradeStyle(trade: AssignTradeResponse) {
    if (trade.isJobDeclined) return 'job-declined-trade';
    else if (trade.branchPreferredTrade && !trade.pmPreferredTrade)
      return 'agency-preferred';
    else if (trade.pmPreferredTrade && !trade.branchPreferredTrade)
      return 'pm-preferred';
    else if (trade.branchPreferredTrade && trade.pmPreferredTrade)
      return 'agency-pm-preferred';
    else return '';
  }

  getBudgetOptionLabel(budget: Budget,isFromAIJobPost:boolean=false) {
    if (budget.option == JobBudgetOptions.CustomizedUnder)
      return `Under $${budget.amount}`;
    if (budget.option == JobBudgetOptions.Custom && isFromAIJobPost)
      return `$${budget.amount}`;
    return JobBudgetOptionsLabel.get(budget.option);
  }
}
